import { CommonTable } from "components";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { getColumns } from "./getColumns";
import { RUB_OPERATION_TYPE_ENUM } from "interfaces";

const lockOperationTypes = [
  RUB_OPERATION_TYPE_ENUM.UNLOCK,
  RUB_OPERATION_TYPE_ENUM.LOCK,
  RUB_OPERATION_TYPE_ENUM.LOCK_WITHDRAWAL,
  RUB_OPERATION_TYPE_ENUM.UNLOCK_WITHDRAWAL,
];

export const RubOperationsList = observer(() => {
  const { rubOperations, user } = useStores();

  return (
    <CommonTable
      id="ro-table"
      store={rubOperations}
      columns={getColumns({ user, rubOperations })}
      whiteBox
      updateWithInterval
      onRow={(record) => {
        return {
          className: `${lockOperationTypes.includes(record.type) ? "opacity-50" : undefined}`,
        };
      }}
    />
  );
});
